import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-about-us',
  templateUrl: './new-about-us.component.html',
  styleUrls: ['./new-about-us.component.less']
})
export class NewAboutUsComponent implements OnInit {

  appLogo: string;
  appheader: string;
  navbarOpen = false;

  constructor(private router: Router) {
    this.appLogo = '../../assets/images/akrti copy.png';
    this.appheader = '../../assets/images/gallery/about-us-img/wood.jpg'
  }


  ngOnInit() {
  }
  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }
}
